import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { CheckCircle, AlertCircle } from 'lucide-react';

const ResultsCard = ({ 
  title, 
  icon: Icon, 
  iconColor, 
  results, 
  className = "" 
}) => {
  if (!results || results.length === 0) return null;

  return (
    <Card className={`shadow-lg ${className}`}>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Icon className={`w-6 h-6 text-${iconColor}-600`} />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {results.map((result, index) => (
            <div 
              key={index}
              className={`p-4 rounded-lg border ${
                result.status === 'success' 
                  ? 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800'
                  : 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800'
              }`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-medium">
                    {result.filename || result.type || 'Upload'}
                  </div>
                  {result.status === 'success' && result.processed_count && (
                    <div className="text-sm text-green-700 dark:text-green-300">
                      Processed {result.processed_count} items
                    </div>
                  )}
                  {result.status === 'success' && result.original_file_path && (
                    <div className="text-sm text-blue-700 dark:text-blue-300">
                      Saved to: {result.original_file_path}
                    </div>
                  )}
                  {result.status === 'success' && result.storage && (
                    <div className="text-sm text-purple-700 dark:text-purple-300">
                      Storage: {result.storage.pinecone_vector_db ? '🔗 Pinecone' : '❌ Pinecone'} | 
                      {result.storage.local_database ? '💾 Local DB' : '❌ Local DB'}
                    </div>
                  )}
                  {result.error && (
                    <div className="text-sm text-red-700 dark:text-red-300">
                      Error: {result.error}
                    </div>
                  )}
                </div>
                {result.status === 'success' ? (
                  <CheckCircle className="w-5 h-5 text-green-500" />
                ) : (
                  <AlertCircle className="w-5 h-5 text-red-500" />
                )}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ResultsCard;
